import {
    FETCH_MESSAGES,
    FETCH_MESSAGES_SUCCESS,
    FETCH_MESSAGES_FAILED,
    SEND_MESSAGE,
    STOP_FETCH_MESSAGES
} from "../store/types";
import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { onValue, push, off, child, update } from "firebase/database";

const chatReadKey = (role) => (role === 'driver' ? 'readDriver' : 'readCustomer');

/** Marca el chat del viaje como leído para conductor o pasajero (quita la burbuja). */
export const markChatRead = (bookingId, role) => async () => {
    if (!bookingId || (role !== 'customer' && role !== 'driver')) return;
    const { singleBookingRef } = firebase;
    try {
        await update(singleBookingRef(bookingId), {
            [`chatMeta/${chatReadKey(role)}`]: Date.now(),
        });
    } catch (error) {
        console.warn('[markChatRead]', bookingId, error);
    }
};

export const fetchChatMessages = (bookingId) => (dispatch) => {

    const {
        chatRef
    } = firebase;
  
    dispatch({
        type: FETCH_MESSAGES,
        payload: bookingId,
    });
    // Foco de pantalla y montaje llaman esto; sin off() se acumulan listeners que repiten cada mensaje.
    off(chatRef(bookingId));
    onValue(chatRef(bookingId), snapshot => {
        if(snapshot.val()){
            let rootEntry = snapshot.val();
            let allMesseges = [];
            for (let key in rootEntry) {
                let entryKey = rootEntry[key]
                for (let msgKey in entryKey) {
                  entryKey[msgKey].smsId = msgKey
                  allMesseges.push(entryKey[msgKey])
                }
            }
            dispatch({
                type: FETCH_MESSAGES_SUCCESS,
                payload: allMesseges,
            });
        }else{
            dispatch({
                type: FETCH_MESSAGES_FAILED,
                payload: store.getState().languagedata.defaultLanguage.chat_not_found,
            });
        }
    })
};

export const sendMessage = (data) => (dispatch) => {

    const {
        chatRef,
        singleBookingRef,
    } = firebase;

    const chatId = data.booking.customer + ','  + data.booking.driver
    var today = new Date();
    var time = today.getHours() + ":" + today.getMinutes();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); 
    var yyyy = today.getFullYear();
    today = mm + ':' + dd + ':' + yyyy;
    const now = Date.now();
    
    const msg = {
        message:data.message,
        from: data.role == 'customer'? data.booking.customer : data.booking.driver,
        type:"msg",
        msgDate:today,
        msgTime:time,
        createdAt: new Date().toString(),
        source: data.role
    };

    const write = push(child(chatRef(data.booking.id), chatId), msg);

    // Metadatos en el booking para burbuja de no leídos en icono de chat (viaje / lista).
    if (data.booking && data.booking.id && (data.role === 'customer' || data.role === 'driver')) {
        update(singleBookingRef(data.booking.id), {
            'chatMeta/lastAt': now,
            'chatMeta/lastSource': data.role,
            'chatMeta/lastPreview': String(data.message || '').slice(0, 80),
            [`chatMeta/${chatReadKey(data.role)}`]: now,
        }).catch((error) => console.warn('[sendMessage] chatMeta', error));
    }

    if(data.role == 'customer'){
        if(data.booking.driver_token || data.booking.driver){
            RequestPushMsg(
                data.booking.driver_token,
                {
                    title: store.getState().languagedata.defaultLanguage.notification_title  + store.getState().languagedata.defaultLanguage.chat_requested,
                    msg: data.message,
                    screen: 'onlineChat',
                    params: { bookingId: data.booking.id, status: data.booking.status }
                },
                data.booking.driver);
        }
    }else{
        if(data.booking.customer_token || data.booking.customer){
            RequestPushMsg(
                data.booking.customer_token,
                {
                    title: store.getState().languagedata.defaultLanguage.notification_title  + store.getState().languagedata.defaultLanguage.chat_requested,
                    msg: data.message,
                    screen: 'onlineChat',
                    params: { bookingId: data.booking.id, status: data.booking.status}
                },
                data.booking.customer);
        }
    }

    dispatch({
        type: SEND_MESSAGE,
        payload: msg,
    });
    return write;
}

export const stopFetchMessages = (bookingId) => (dispatch) => {

    const {
        chatRef 
    } = firebase;

    dispatch({
        type: STOP_FETCH_MESSAGES,
        payload: bookingId,
    });
    off(chatRef(bookingId));
}